import type { DateOnlyFormat, DateRangeFormat, FormatDateOptions, NullableDateInput } from '@localization/formatters/dateFormatter';
import type { EventLocaleFormatter } from '@localization/hooks/useEventLocaleFormatter';
import type { EventDetailsData } from './EventDetails.types';

type DateFormatters = Pick<EventLocaleFormatter, 'formatDate' | 'formatEventDateRange'>;

// Multi-day event date (PRNT-4321). When a range is saved, render the range (start = the event date,
// end = content.eventEndDate) or the verbatim custom text; otherwise fall back to the single formatted
// date. Derived from saved data alone (not the flag): the flag gates discovery in the editor, so saved
// range data must always render regardless of flag state. Shared by the welcome page (EventDetailsGuest)
// and the registry header so the two surfaces stay in sync.
export const resolveEventDateDisplay = (
  content: EventDetailsData,
  startTimestamp: NullableDateInput,
  options: FormatDateOptions,
  { formatDate, formatEventDateRange }: DateFormatters,
): string | undefined => {
  const dateFormat = (content.dateFormat ?? 'weekday, dd MMMM yyyy') as DateOnlyFormat;
  const isRangeMode = content.dateDisplayType === 'dateRange';
  const customText = content.customText?.trim();
  return isRangeMode && content.dateRangeFormat === 'custom'
    ? customText || formatDate(startTimestamp, dateFormat, options)
    : isRangeMode && content.eventEndDate
      ? formatEventDateRange(startTimestamp, content.eventEndDate, (content.dateRangeFormat as DateRangeFormat) ?? 'weekday, dd MMMM yyyy', options)
      : formatDate(startTimestamp, dateFormat, options);
};
